// extracted by mini-css-extract-plugin
export default {"aboutText":"aboutUs_aboutText__Ske1-","aboutCont":"aboutUs_aboutCont__7kwah","linkCont":"aboutUs_linkCont__bpTxX","linkText":"aboutUs_linkText__UlnME"};